import WhtsappIcon from "./svgs/WhtsappIcon";

export default {
  WhtsappIcon
};
